import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { InvestmentPlanDataService } from '../../services/investment-plan-data.service'
import { FundriskService } from 'src/app/services/fundrisk.service';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-investing-plan',
  templateUrl: './investing-plan.component.html',
  styleUrls: ['./investing-plan.component.scss']
})
export class InvestingPlanComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChild('chart')
  chart: ElementRef

  @ViewChild('scrollTo') scrollTo: ElementRef

  @ViewChild('formStart') formStart: ElementRef

  private sub: any

  constructor(private router: Router, private route: ActivatedRoute, private shareData: InvestmentPlanDataService, private fundRiskService: FundriskService) {
    this.doughnutChartData = []
  }

  headerTitle: string
  activeMenu = '2'
  menuList = [
    // {
    //   title: 'เรียนรู้การลงทุน',
    //   key: '1'
    // },
    {
      title: this.language.planinvestmentmenu1,
      key: '1'
    },
    {
      title: this.language.planinvestmentmenu2,
      key: '2'
    },
    {
      title: this.language.planinvestmentmenu3,
      key: '3'
    },
    // {
    //   title: 'จัดพอร์ทตามความเสี่ยง',
    //   key: '4'
    // },
  ]

  chairActive = false
  taxActive = false
  newbeeActive = true

  calFormClick: any

  newbeeCal = false
  taxCal = false
  chairCal = false

  hideNewbeeForm: boolean
  hideTaxForm: boolean
  hideChairForm: boolean

  formTotalScore: number

  investorType: string
  investment: string
  recommRisk: string
  riskLevel: string
  ageRange: string

  row: boolean
  mid: boolean
  high: boolean
  userRisk: number


  safeMoney: number
  investmentMoney: number
  directInvestmentMoney: number
  rmfMoney: number
  otherMoney: number

  ageNow: number
  retireAge: number
  maxAge: number
  payAfterRetire: number
  rate: number

  infla: any

  provident: any
  riskLabel: Array<any> = []
  riskLabelTH: Array<any> = []
  riskLabelId: Array<any> = []
  risk: Array<any> = []
  expectedReturn: Array<any> = []
  SD: Array<any> = []
  Drawdown: Array<any> = []
  inflation: any
  inflationRate: any
  riskId: number

  investmentHorizon: number
  retirementLength: number

  pvRate: any
  pvPeriod: any
  pv: any

  fvRate: any
  fvPeriod: any
  fv: any

  pmtRate: any
  pmtPeriod: any
  pmt: any

  aom: any

  expectedR: any
  expectedRStr: any
  investmentAllocation: Array<Object> = []

  savePercent: any

  goalMoney: any
  timeHorizon: any
  generalAom: any
  generaldRate: any
  generaldPeriod: any
  generaldFvRate: any
  generaldFv: any
  generaldInvestment: any

  sd: any
  drawndown: any

  //require input
  currentAgeRequire: boolean
  retirementAgeRequire: boolean
  lifeSpanRequire: boolean
  retirementPayRequire: boolean
  inflatioinRateRequire: boolean
  timeHorizonRequire: boolean
  targetMoneyRequire: boolean

  // beginer risk mapping and show
  beginerRiskTitle: any
  riskDetail1_1: any;
  riskDetail1_1P: any;
  riskDetail1_2: any;
  riskDetail1_2P: any;
  riskDetail3_1: any;
  riskDetail3_1P: any;
  riskDetail3_2: any;
  riskDetail3_2P: any;
  riskDetail2p: any;

  p1: any;
  p2: any;
  p3: any;
  p4: any;
  p5: any;
  p6: any;

  donut: any
  doughnutChartData: any

  // chart data
  mmGraph: any
  fiGraph: any
  miGraph: any
  eqGraph: any
  propGraph: any
  gqeGraph: any

  fundList1: any;
  fundList2: any;
  fundList3: any;
  fundList4: any;
  fundList5: any;
  fundList6: any;
  hideStep: boolean = false

  flag: any

  onMenuChange(key) {
    this.activeMenu = key
  }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.sub = this.route.params.subscribe(params => {

      // sessionStorage.setItem('testSession','test')
      this.headerTitle = this.language.planinvestmentheader
      if (sessionStorage.getItem('riskId') != null) {
        this.riskId = parseInt(sessionStorage.getItem('riskId'))
      }

      if (sessionStorage.getItem('userRisk') != null) {
        this.userRisk = parseInt(sessionStorage.getItem('userRisk'))
      }

      let menuClick = sessionStorage.getItem('clickMenu')

      if (menuClick == null) {
        // first time click invest plan
        this.setActive('มือใหม่หัดลงทุน')
        this.hideNewbeeForm = false
        this.hideTaxForm = false
        this.hideChairForm = false
      } else if (menuClick != null) {

        this.setActive(menuClick)
      }

    })

    this.shareData.getWebServiceInflation().subscribe(response => {

      this.infla = parseFloat(response[0].r1)

      this.shareData.getWebserviceProvident().subscribe(response => {
        this.provident = parseFloat(response[0].r1)

        this.shareData.getWebserviceExpectedReturn().subscribe(response => {
          let eptRr1 = parseFloat(response[0].r1)
          let eptRr2 = parseFloat(response[0].r2)
          let eptRr3 = parseFloat(response[0].r3)
          let eptRr4 = parseFloat(response[0].r4)
          let eptRr5 = parseFloat(response[0].r5)
          this.expectedReturn.push(eptRr1, eptRr2, eptRr3, eptRr4, eptRr5)

          this.shareData.getWebserviceSD().subscribe(response => {
            let sdr1 = parseFloat(response[0].r1)
            let sdr2 = parseFloat(response[0].r2)
            let sdr3 = parseFloat(response[0].r3)
            let sdr4 = parseFloat(response[0].r4)
            let sdr5 = parseFloat(response[0].r5)
            this.SD.push(sdr1, sdr2, sdr3, sdr4, sdr5)

            this.shareData.getWebserviceDrawDown().subscribe(response => {
              let ddr1 = parseFloat(response[0].r1)
              let ddr2 = parseFloat(response[0].r2)
              let ddr3 = parseFloat(response[0].r3)
              let ddr4 = parseFloat(response[0].r4)
              let ddr5 = parseFloat(response[0].r5)
              this.Drawdown.push(ddr1, ddr2, ddr3, ddr4, ddr5)

            })

            this.shareData.getWebserviceInvestAlloName().subscribe(response => {
              
              this.riskLabel.push(response[0].fundNameEn, response[1].fundNameEn,
                response[2].fundNameEn, response[3].fundNameEn, response[4].fundNameEn)

              this.riskLabelTH.push(response[0].fundNameTh, response[1].fundNameTh,
                response[2].fundNameTh, response[3].fundNameTh, response[4].fundNameTh)

              this.riskLabelId.push(response[0].fundTypeId, response[1].fundTypeId,
                response[2].fundTypeId, response[3].fundTypeId, response[4].fundTypeId)
              this.shareData.getWebserviceInvestmentAllo().subscribe(response => {
                let row1 = [parseFloat(response[0].r1), parseFloat(response[1].r1),
                parseFloat(response[2].r1), parseFloat(response[3].r1), parseFloat(response[4].r1)]

                let row2 = [parseFloat(response[0].r2), parseFloat(response[1].r2),
                parseFloat(response[2].r2), parseFloat(response[3].r2), parseFloat(response[4].r2)]

                let row3 = [parseFloat(response[0].r3), parseFloat(response[1].r3),
                parseFloat(response[2].r3), parseFloat(response[3].r3), parseFloat(response[4].r3)]

                let row4 = [parseFloat(response[0].r4), parseFloat(response[1].r4),
                parseFloat(response[2].r4), parseFloat(response[3].r4), parseFloat(response[4].r4)]

                let row5 = [parseFloat(response[0].r5), parseFloat(response[1].r5),
                parseFloat(response[2].r5), parseFloat(response[3].r5), parseFloat(response[4].r5)]

                this.risk.push(row1, row2, row3, row4, row5)
              })
            })
          })
        })
      })
    })

    this.currentAgeRequire = false
    this.retirementAgeRequire = false
    this.lifeSpanRequire = false
    this.retirementPayRequire = false
    this.inflatioinRateRequire = false
    this.timeHorizonRequire = false
    this.newbeeCal = false
    this.row = false
    this.mid = false
    this.high = false
  }


  setActive(targetClick) {
    this.headerTitle = this.language.planinvestmentheader
    if (sessionStorage.getItem('clickMenu') == null) {
      if (targetClick === 'เพื่อเกษียณ') {
        this.taxActive = false
        this.newbeeActive = false
        this.chairActive = true
        sessionStorage.setItem('clickMenu', 'เพื่อเกษียณ')

      } else if (targetClick === 'เพื่อเป้าหมาย') {
        this.chairActive = false
        this.newbeeActive = false
        this.taxActive = true
        sessionStorage.setItem('clickMenu', 'เพื่อเป้าหมาย')

      } else if (targetClick === 'มือใหม่หัดลงทุน') {
        this.taxActive = false
        this.chairActive = false
        this.newbeeActive = true
        sessionStorage.setItem('clickMenu', 'มือใหม่หัดลงทุน')
      }
    } else if (sessionStorage.getItem('clickMenu') != null && this.userRisk == undefined) {

      if (targetClick === 'เพื่อเกษียณ') {
        this.taxActive = false
        this.newbeeActive = false
        this.chairActive = true
        sessionStorage.setItem('clickMenu', 'เพื่อเกษียณ')

      } else if (targetClick === 'เพื่อเป้าหมาย') {
        this.chairActive = false
        this.newbeeActive = false
        this.taxActive = true
        sessionStorage.setItem('clickMenu', 'เพื่อเป้าหมาย')

      } else if (targetClick === 'มือใหม่หัดลงทุน') {
        this.taxActive = false
        this.chairActive = false
        this.newbeeActive = true
        sessionStorage.setItem('clickMenu', 'มือใหม่หัดลงทุน')
      }
    } else if (sessionStorage.getItem('clickMenu') != null && this.userRisk != undefined) {
      if (targetClick === 'เพื่อเกษียณ') {
        this.taxActive = false
        this.newbeeActive = false
        this.chairActive = true
        this.taxCal = false
        this.chairCal = false
        this.newbeeCal = false
        this.hideChairForm = false
        sessionStorage.setItem('clickMenu', 'เพื่อเกษียณ')
      } else if (targetClick === 'เพื่อเป้าหมาย') {
        this.hideTaxForm = false
        this.chairActive = false
        this.newbeeActive = false
        this.taxActive = true
        this.taxCal = false
        this.chairCal = false
        this.newbeeCal = false

        sessionStorage.setItem('clickMenu', 'เพื่อเป้าหมาย')
      } else if (targetClick === 'มือใหม่หัดลงทุน') {

        this.taxActive = false
        this.chairActive = false
        this.newbeeActive = true
        this.taxCal = false
        this.chairCal = false
        this.newbeeCal = false
        this.hideNewbeeForm = false
        this.hideTaxForm = false
        this.hideChairForm = false
        sessionStorage.setItem('clickMenu', 'มือใหม่หัดลงทุน')
      }
    }

  }

  calChairForm(check) {

    if (check === 'มือใหม่หัดลงทุน') {

      this.taxCal = false
      this.chairCal = false
      this.newbeeCal = true
      this.hideNewbeeForm = true
      this.hideTaxForm = false
      this.hideChairForm = false
      this.headerTitle = this.language.allocation1
      this.hideStep = true
      this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
    } else if (check === 'เพื่อเป้าหมาย') {

      this.taxCal = true
      this.chairCal = false
      this.newbeeCal = false
      this.hideTaxForm = true
      this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
    } else if (check === 'เพื่อเกษียณ') {

      this.taxCal = false
      this.chairCal = true
      this.newbeeCal = false
      this.hideChairForm = true
      this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  newbeeFormAgain() {
    this.newbeeCal = false
    this.hideNewbeeForm = false
    this.hideStep = false
    this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  setTotalScore(event) {

    this.formTotalScore = event
    this.setRisk()
  }

  setAgeRange(event) {
    this.ageRange = event
  }

  setRisk() {
    this.doughnutChartData = []
    if (this.formTotalScore < 15) {
      this.investorType = this.language.allocation10
      this.investment = this.language.allocation15
      this.recommRisk = this.language.allocation20
      this.riskLevel = this.language.allocation23
      this.userRisk = 1
      this.riskId = 0
      sessionStorage.setItem('userRisk', this.userRisk.toString())
      sessionStorage.setItem('riskId', this.riskId.toString())

      this.fundRiskService.get_riskLevelByRiskID("1").subscribe(response => {
        this.riskDetail2p = response[0]['riskDetail2p']
        
        if (this.flag == 'th') {
          this.beginerRiskTitle = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

        } else {
          this.beginerRiskTitle = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }
        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              softConnector: false
            },
          }]
        });

        this.fundRiskService.getFundRiskMapp("1", "1").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList1 = response;
          }


        })

        this.fundRiskService.getFundRiskMapp("2", "1").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList2 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("3", "1").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList3 = response;
          }



        })

        this.fundRiskService.getFundRiskMapp("4", "1").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList4 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("5", "1").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList5 = response;
          }
        })

        this.row = true
        this.mid = false
        this.high = false
      })


    } else if (this.formTotalScore >= 15 && this.formTotalScore < 22) {
      this.investorType = this.language.allocation11
      this.investment = this.language.allocation16
      this.recommRisk = this.language.allocation21
      this.riskLevel = this.language.allocation24
      this.userRisk = 2
      this.riskId = 1
      sessionStorage.setItem('userRisk', this.userRisk.toString())
      sessionStorage.setItem('riskId', this.riskId.toString())

      this.fundRiskService.get_riskLevelByRiskID("2").subscribe(response => {
        this.riskDetail2p = response[0]['riskDetail2p']
        if (this.flag == 'th') {
          this.beginerRiskTitle = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

        } else {
          this.beginerRiskTitle = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              softConnector: false
            },
          }]
        });

        this.fundRiskService.getFundRiskMapp("1", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList1 = response;
          }

        })

        this.fundRiskService.getFundRiskMapp("2", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList2 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("3", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList3 = response;
          }



        })

        this.fundRiskService.getFundRiskMapp("4", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList4 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("5", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList5 = response;
          }
        })

        // this.fundRiskService.getFundRiskMapp("7", "2").subscribe(response => {
        //   this.fundList6 = response

        // })

        this.row = false
        this.mid = true
        this.high = false
      })

    } else if (this.formTotalScore >= 22 && this.formTotalScore < 30) {
      this.investorType = this.language.allocation12
      this.investment = this.language.allocation17
      this.recommRisk = this.language.allocation21
      this.riskLevel = this.language.allocation24
      this.userRisk = 3
      this.riskId = 2
      sessionStorage.setItem('userRisk', this.userRisk.toString())
      sessionStorage.setItem('riskId', this.riskId.toString())

      this.fundRiskService.get_riskLevelByRiskID("2").subscribe(response => {
        this.riskDetail2p = response[0]['riskDetail2p']
        if (this.flag == 'th') {
          this.beginerRiskTitle = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

        } else {
          this.beginerRiskTitle = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              softConnector: false
            },
          }]
        });

        this.fundRiskService.getFundRiskMapp("1", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList1 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("2", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList2 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("3", "2").subscribe(response => {


          if (response[0]['fundNameEn'] != "") {
            this.fundList3 = response;
          }

        })

        this.fundRiskService.getFundRiskMapp("4", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList4 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("5", "2").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList5 = response;
          }
        })

        // this.fundRiskService.getFundRiskMapp("7", "2").subscribe(response => {
        //   this.fundList6 = response

        // })

        this.row = false
        this.mid = true
        this.high = false
      })

    } else if (this.formTotalScore >= 30 && this.formTotalScore < 37) {
      this.investorType = this.language.allocation13
      this.investment = this.language.allocation18
      this.recommRisk = this.language.allocation22
      this.riskLevel = this.language.allocation25
      this.userRisk = 4
      this.riskId = 3
      sessionStorage.setItem('userRisk', this.userRisk.toString())
      sessionStorage.setItem('riskId', this.riskId.toString())

      this.fundRiskService.get_riskLevelByRiskID("7").subscribe(response => {
        this.riskDetail2p = response[0]['riskDetail2p']
        if (this.flag == 'th') {
          this.beginerRiskTitle = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

        } else {
          this.beginerRiskTitle = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              softConnector: false
            },
          }]
        });

        this.fundRiskService.getFundRiskMapp("1", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList1 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("2", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList2 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("3", "7").subscribe(response => {


          if (response[0]['fundNameEn'] != "") {
            this.fundList3 = response;
          }

        })

        this.fundRiskService.getFundRiskMapp("4", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList4 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("5", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList5 = response;
          }
        })

        // this.fundRiskService.getFundRiskMapp("7", "7").subscribe(response => {
        //   this.fundList6 = response

        // })

        this.row = false
        this.mid = false
        this.high = true
      })

    } else if (this.formTotalScore >= 37) {
      this.investorType = this.language.allocation14
      this.investment = this.language.allocation19
      this.recommRisk = this.language.allocation22
      this.riskLevel = this.language.allocation25
      this.userRisk = 5
      this.riskId = 4
      sessionStorage.setItem('userRisk', this.userRisk.toString())
      sessionStorage.setItem('riskId', this.riskId.toString())

      this.fundRiskService.get_riskLevelByRiskID("7").subscribe(response => {
        this.riskDetail2p = response[0]['riskDetail2p']
        if (this.flag == 'th') {
          this.beginerRiskTitle = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

        } else {
          this.beginerRiskTitle = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '70%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '35%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              softConnector: false
            },
          }]
        });

        this.fundRiskService.getFundRiskMapp("1", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList1 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("2", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList2 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("3", "7").subscribe(response => {



          if (response[0]['fundNameEn'] != "") {
            this.fundList3 = response;
          }

        })

        this.fundRiskService.getFundRiskMapp("4", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList4 = response;
          }
        })

        this.fundRiskService.getFundRiskMapp("5", "7").subscribe(response => {
          if (response[0]['fundNameEn'] != "") {
            this.fundList5 = response;
          }
        })

        // this.fundRiskService.getFundRiskMapp("7", "7").subscribe(response => {
        //   this.fundList6 = response

        // })

        this.row = false
        this.mid = false
        this.high = true
      })

    }

  }

  whatClass(val, fundType) {
    let fundRisk = parseInt(val)
    if (this.userRisk < fundRisk) {
      if (fundType == 'Long-Term Equity Fund (LTF)' || fundType == 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return 'tax-fund'
        } else {
          return 'tax-high-risk'
        }
      } else if (fundType != 'Long-Term Equity Fund (LTF)' || fundType != 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return '-bg-white'
        } else {
          return 'nontax-high-risk'
        }
      }
    } else if (this.userRisk >= fundRisk) {
      if (fundType == 'Long-Term Equity Fund (LTF)' || fundType == 'Retirement Mutual Fund (RMF)') {
        if ((fundRisk > 5 && fundRisk <= 8) && this.userRisk == 5) {
          return 'tax-fund'
        } else {
          return 'tax-fund'
        }
      } else if (fundType != 'Long-Term Equity Fund (LTF)' || fundType != 'Retirement Mutual Fund (RMF)') {
        return '-bg-white'
      }
    }

  }

  setSafeMoney(event) {
    if (event === '') {
      this.safeMoney = 0
    } else {
      this.safeMoney = parseInt(event)
    }

  }

  setGoalMoney(event) {
    this.goalMoney = parseInt(event)
  }

  setTimeHorizon(event) {
    this.timeHorizon = parseInt(event)
  }

  setInvestmentMoney(event) {
    this.investmentMoney = parseInt(event)
  }

  setDirectInvestmentMoney(event) {
    this.directInvestmentMoney = parseInt(event)
  }

  setRMFMoney(event) {
    this.rmfMoney = parseInt(event)
  }

  setOtherMoney(event) {
    this.otherMoney = parseInt(event)
  }

  setAgeNow(event) {
    this.ageNow = parseInt(event)
  }

  setRetireAge(event) {
    this.retireAge = parseInt(event)
  }

  setMaxAge(event) {
    this.maxAge = parseInt(event)
  }

  setPayAfterRetire(event) {
    this.payAfterRetire = parseInt(event)
  }


  presentValue(rate, period, pmt, fv) {
    if (rate == 0) {
      return fv + pmt * period
    } else {
      return fv / Math.pow(1 + rate, period) + pmt / rate * (1 - (1 / Math.pow(1 + rate, period)));
    }
  }

  futureValue(rate, period, pmt, pv) {
    if (rate == 0) {
      return pv + pmt * period;
    }
    else {
      return pv * Math.pow((1 + rate), period) + pmt / rate * (Math.pow((1 + rate), period) - 1);
    }
  }

  payment(rate, period, pv, fv) {

    if (rate == 0) {
      return (fv - pv) / period;
    }
    else {
      return (fv * rate - pv * rate * Math.pow(1 + rate, period)) / (Math.pow(1 + rate, period) - 1);
    }
  }

  calculateChair() {
    this.investmentAllocation = []
    let riskId = parseInt(sessionStorage.getItem('userRisk')) - 1
    if (this.safeMoney == undefined) {
      this.safeMoney = 0
    }

    this.retirementLength = this.maxAge - this.retireAge
    this.investmentHorizon = this.retireAge - this.ageNow
    this.pvRate = Math.pow(1 + (this.provident - this.infla), (1 / 12)) - 1
    this.pvPeriod = 12 * this.retirementLength;
    this.pv = Math.round(this.presentValue(this.pvRate, this.pvPeriod, this.payAfterRetire, 0))

    this.fvRate = Math.pow(1 + (this.expectedReturn[riskId] - this.infla), (1 / 12)) - 1;
    this.fvPeriod = 12 * this.investmentHorizon;
    this.fv = Math.round(this.futureValue(this.fvRate, this.fvPeriod, 0, this.safeMoney))

    if (this.pv - this.fv <= 0) {
      this.aom = 0
    } else {
      this.aom = this.pv - this.fv
    }

    this.pmtRate = Math.pow(1 + (this.expectedReturn[riskId] - this.infla), (1 / 12)) - 1;
    this.pmtPeriod = 12 * this.investmentHorizon
    this.pmt = this.payment(this.pmtRate, this.pmtPeriod, 0, this.aom)

    this.expectedR = (this.expectedReturn[riskId] * 100).toFixed(2)
    this.expectedRStr = Math.round(this.expectedR).toString()

    for (var r in this.risk[riskId]) {
      this.investmentAllocation.push({
        fundType: this.riskLabel[r],
        fundTypeTH: this.riskLabelTH[r],
        valuePercent: Math.round(this.risk[riskId][r] * 100),
        fundTypeId: this.riskLabelId[r],
        fundMapp: null,
      })
    }

    this.savePercent = (this.fv * 100) / this.pv

    this.sd = (this.SD[riskId] * 100).toFixed(2)
    this.drawndown = (this.Drawdown[riskId] * 100).toFixed(2)


    sessionStorage.setItem('retirementLength', JSON.stringify(this.retirementLength))
    sessionStorage.setItem('investmentHorizon', JSON.stringify(this.investmentHorizon))
    sessionStorage.setItem('payAfterRetire', JSON.stringify(this.payAfterRetire))
    sessionStorage.setItem('pv', JSON.stringify(this.pv))
    sessionStorage.setItem('fv', JSON.stringify(this.fv))
    sessionStorage.setItem('aom', JSON.stringify(this.aom))
    sessionStorage.setItem('expectedR', this.expectedR)
    sessionStorage.setItem('expectedRStr', this.expectedRStr)

    sessionStorage.setItem('investmentAllocation', JSON.stringify(this.investmentAllocation))
    sessionStorage.setItem('safeMoney', JSON.stringify(this.safeMoney))
    sessionStorage.setItem('pmt', JSON.stringify(this.pmt))
    sessionStorage.setItem('savePercent', JSON.stringify(this.savePercent))

    sessionStorage.setItem('sd', this.sd)
    sessionStorage.setItem('drawndown', this.drawndown)
    sessionStorage.setItem('cilckFrom', 'เกษียณ')

    this.goToStepTwo('retirement')
  }

  calculateGenaral() {
    this.investmentAllocation = []
    let riskId = parseInt(sessionStorage.getItem('userRisk')) - 1

    if (this.goalMoney == undefined) {
      this.goalMoney = 0
    }
    if (this.safeMoney == undefined) {
      this.safeMoney = 0
    }

    this.generalAom = this.safeMoney
    this.generaldRate = Math.pow((1 + (this.expectedReturn[riskId])), (1 / 12)) - 1
    this.generaldPeriod = 12 * this.timeHorizon
    this.generaldFvRate = Math.pow((1 + (this.expectedReturn[riskId])), (1 / 12)) - 1
    this.generaldFv = this.goalMoney - this.futureValue(this.generaldFvRate, this.generaldPeriod, 0, this.generalAom)
    this.generaldInvestment = this.payment(this.generaldRate, this.generaldPeriod, 0, this.generaldFv);
    this.expectedR = (this.expectedReturn[riskId] * 100).toFixed(2)

    for (var r in this.risk[riskId]) {
      
      this.investmentAllocation.push({
        fundType: this.riskLabel[r],
        fundTypeTH: this.riskLabelTH[r],
        valuePercent: Math.round(this.risk[riskId][r] * 100),
        fundTypeId: this.riskLabelId[r],
        fundMapp: null,
      })
    }
    this.sd = (this.SD[riskId] * 100).toFixed(2)
    this.drawndown = (this.Drawdown[riskId] * 100).toFixed(2)

    if (this.generaldInvestment < 0) {
      sessionStorage.setItem('generaldInvestment', '0')
    } else {
      sessionStorage.setItem('generaldInvestment', this.generaldInvestment)
    }

    sessionStorage.setItem('sd', this.sd)
    sessionStorage.setItem('drawndown', this.drawndown)

    sessionStorage.setItem('expectedR', this.expectedR)
    sessionStorage.setItem('investmentAllocation', JSON.stringify(this.investmentAllocation))
    sessionStorage.setItem('cilckFrom', 'เป้าหมาย')

    this.goToStepTwo('target')
  }

  goToStepTwo(clickFrom) {

    if (clickFrom === 'retirement') {

      if (isNaN(this.ageNow) || this.ageNow == undefined || this.ageNow == 0) {
        this.currentAgeRequire = true
      } else {
        this.currentAgeRequire = false
      }
      if (isNaN(this.retireAge) || this.retireAge == undefined || this.retireAge == 0 || (this.retireAge < this.ageNow)) {
        this.retirementAgeRequire = true
      } else {
        this.retirementAgeRequire = false
      }
      if (isNaN(this.maxAge) || this.maxAge == undefined || this.maxAge == 0) {
        this.lifeSpanRequire = true
      } else {
        this.lifeSpanRequire = false
      }
      if (isNaN(this.payAfterRetire) || this.payAfterRetire == undefined || this.payAfterRetire == 0) {
        this.retirementPayRequire = true
      } else {
        this.retirementPayRequire = false
      }
      if (!this.currentAgeRequire && !this.retirementAgeRequire && !this.lifeSpanRequire
        && !this.retirementPayRequire) {
        this.router.navigate(['/calculate/step2'])
      }
    } else if (clickFrom === 'target') {

      if (isNaN(this.timeHorizon) || this.timeHorizon == undefined || this.timeHorizon == 0) {
        this.timeHorizonRequire = true
      } else {
        this.timeHorizonRequire = false
      }

      if (isNaN(this.goalMoney) || this.goalMoney == undefined || this.goalMoney == 0) {
        this.targetMoneyRequire = true
      } else {
        this.targetMoneyRequire = false
      }
      if (!this.timeHorizonRequire) {
        this.router.navigate(['/calculate/step2'])
      }

    }

  }

  checkCompleteForm(value) {
    if (value == false) {
      this.formStart.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }
  }

}
